export default "__VITE_ASSET__ed3bf201__"